import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardSubtitle, CardTitle, Col, Row } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'
import NewVehicleTypeForm from './partials/NewVehicleTypeForm'
import VehicleTypesTable from './partials/VehicleTypesTable'

import { getVehicleTypes } from './services'
import { handleError } from '../../helpers'

export default function VehicleTypesList() {
	const [vehicleTypes, setVehicleTypes] = useState(null)
	const [filterType, setFilterType] = useState('name')
	const [filterValue, setFilterValue] = useState('')

	useEffect(() => {
		!vehicleTypes && getVehicleTypes({
			[`filter[${filterType}]`]: filterValue,
			include: 'appointmentsCount',
			sort: '-created_at',
		})
			.then(res => setVehicleTypes(res.data.data))
			.catch(error => handleError(error))
	}, [ vehicleTypes, filterType, filterValue ])

	return (
		<React.Fragment>
			<Row>
				<Col md="4">
					<Card>
						<CardBody>
							<CardTitle>Agregar Tipo de Vehículo</CardTitle>
							<CardSubtitle>Crear nuevo registro</CardSubtitle>
							<hr className='mt-10' />
							<NewVehicleTypeForm reload={() => setVehicleTypes(null)} />
						</CardBody>
					</Card>
				</Col>
				<Col>
					<ListTopBar 
						title="Tipos de Vehículos"
						subtitle="Listado general de la plataforma"
						filterType={filterType}
						setFilterType={setFilterType}
						filterValue={filterValue}
						setFilterValue={setFilterValue}
						reload={() => setVehicleTypes(null)}
						options={[
							{ label: 'Buscar por nombre', value: 'name' },
						]}
						className="mb-10"
					/>
					<Card>
						<CardBody>
							<VehicleTypesTable 
								vehicleTypes={vehicleTypes}
								reload={() => setVehicleTypes(null)}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}